import React, { useState, useEffect } from "react";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomChartsTitle,
  CustomSubtitle,
  CustomTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Avatar,
  Button,
} from "@mui/material";
import WalletIcon from "../../assets/Icon/WalletIcon.png";
import CustomTransactionTable from "../../components/Custom/CustomTransactionTable";

const Decarbonization = () => {
  const { t } = useTranslation();
  const [programName, setProgramName] = useState("");
  const navigate = useNavigate();
  const columns = [
    { label: "Date", field: "date" },
    { label: "Amount", field: "amount" },
    { label: "Status", field: "status" },
  ];

  useEffect(() => {
    const programName = localStorage.getItem("program_name");
    if (programName) {
      setProgramName(programName);
    } else {
      setProgramName("Know about Program 1");
    }
  }, []);

  const data = [
    // { date: "12-10-2023", amount: "₹ 50,205", status: "Credited" },
  ];

  const handleViewProgram = () => {
    navigate("/decarbonization/program-list");
  };

  const programs = [
    { name: programName },
    { name: t("Know About Program 2") },
    { name: t("New Programs 3") },
    { name: t("My Programs 3") },
  ];

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Decarbonization")}</CustomTitle>

            <Box sx={{ marginTop: "20px" }}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <CustomDashboardCard
                    title={t("GHG EMISSION")}
                    data={0}
                    unit="MMT"
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomDashboardCard
                    title={t("ACRES")}
                    data={0}
                    unit="Acres"
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Transaction History")}</CustomChartsTitle>
              <Grid container spacing={1.5} sx={{ padding: "10px 0" }}>
                <Grid item xs={4}>
                  <Card style={{ boxShadow: "none" }}>
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        sx={{ padding: "10px 0" }}
                      >
                        <Avatar
                          alt="Wallet Image"
                          src={WalletIcon} // Using the imported image as the source
                          sx={{
                            width: 60,
                            height: 60,
                          }}
                        />
                        <Typography
                          fontSize="10px"
                          textAlign="center"
                          sx={{ padding: "10px 0" }}
                        >
                          {t("Current Balance")}
                        </Typography>

                        <Typography
                          fontSize="10px"
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            border: "1px solid #B5B5B5",
                            borderRadius: "4px",
                            padding: "4px 0",
                          }}
                        >
                          0
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={8}>
                  <CustomTransactionTable columns={columns} data={data} />
                </Grid>
              </Grid>
            </Box>

            <Box>
              <CustomChartsTitle>{t("Programs")}</CustomChartsTitle>
              <Grid container spacing={1} sx={{ padding: "10px 0" }}>
                {programs.map((program, index) => (
                  <Grid item xs={6} key={index}>
                    <Box
                      sx={{ boxShadow: "none", cursor: "pointer" }}
                      onClick={handleViewProgram}
                    >
                      <Card sx={{ boxShadow: "none" }}>
                        <CardContent
                          sx={{ textAlign: "center", padding: "24px 10px" }}
                        >
                          <CustomValue>{program.name}</CustomValue>
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Payments")}</CustomChartsTitle>
              <Box sx={{ padding: "10px 0", textAlign: "center" }}>
                <Card sx={{ boxShadow: "none", padding: "20px 10px" }}>
                  <CustomSubtitle>
                    {t(`You have not signed up for any decarbonization program yet.
            Click here to find out which programs are available to you.`)}
                  </CustomSubtitle>

                  <Button
                    variant="contained"
                    sx={{
                      padding: "15px 50px",
                      height: "20px",
                      color: "white",
                      marginTop: "10px",
                      fontSize: "10px",
                      border: "1px solid #B5B5B5",
                      boxShadow: "none",
                    }}
                    onClick={handleViewProgram}
                  >
                    {t("View Programs")}
                  </Button>
                </Card>
              </Box>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default Decarbonization;
